import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class ExclusionListService {

  constructor(private http: HttpClient) { }

  /**
   * Load consolidation groups for filing key dropdown
   */
  loadConsolGroups(
    baseUrl: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_id=32516`;
    
    // Build params
    let params: any = {
      action_code: 'n34mwg'
    };
    params = _.merge({}, params, globalService?.globalParams || {}, filterParams);
    
    // Convert to URLEncoded format
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }

  /**
   * Save exclusion list entity
   */
  saveExclusionList(
    baseUrl: string,
    jsonObj: any,
    jsonSettings: any,
    globalService: any,
    filterParams: any = {},
    scenarioCode: string = 'RAF',
    isIssueKeyEnabled: string = 'N',
    rowData: any = null
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=08qlz6`;
    
    // Build checkLockedbj exactly like AngularJS JsonObjectFactory
    const checkLockedbj = [{
      "consol_group_key": parseInt(rowData?.FILING_KEY || jsonObj.FILING_KEY || filterParams?.filing_key || 1),
      "scenario_key": String(filterParams?.scenario || 74)
    }];
    
    // Build params exactly like AngularJS
    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ json_data: JSON.stringify([jsonObj]) }, params);
    params = _.extend({ jsonSettings: JSON.stringify(jsonSettings) }, params);
    params.is_issue_key_enabled = isIssueKeyEnabled;
    params.scenarioCode = scenarioCode;
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    
    // Convert to URLEncoded format
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}

